import appleMap from '@/icons/apple-maps.svg';
import googleMapIcon from '@/icons/google-map.svg';
import googleMap from '@/icons/google.svg';
import wazeMap from '@/icons/waze.svg';
import { NavigationTypes } from '@/types/settings';
export const DEFAULT_TIMEZONE = 'Europe/Kyiv';
export const NUM_LOCALE = 'en-US';
export const MOBILE_WIDTH = 1200;
export const APP_STORE_URL = 'https://apps.apple.com/app/driver-portal-by-mytaxicrm/id6761754327';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mytaxicrm.driverapp';
export const routes = {
    auth: {
        s: 'auth',
        f: '/auth'
    },
    login: {
        s: 'login',
        f: '/login'
    },
    registration: {
        s: 'invite',
        f: '/invite/:inviteId'
    },
    resetPassword: {
        s: 'reset-password-link',
        f: '/reset-password-link/:resetPasswordId'
    },
    blocked: {
        s: 'blocked',
        f: '/blocked'
    },
    errorPage: {
        s: 'error-page',
        f: '/error-page'
    },
    // PAGES
    cabinet: {
        s: 'cabinet',
        f: '/cabinet'
    },
    carTransfer: {
        s: 'car-acceptance-transfer',
        f: '/car-acceptance-transfer'
    },
    returnCar: {
        s: 'return-car',
        f: '/return-car'
    },
    officeTrips: {
        s: 'office-trips',
        f: '/office-trips'
    },
    createOfficeTrips: {
        s: 'create-office-trips',
        f: '/create-office-trips'
    },
    cars: {
        s: 'cars',
        f: '/cars'
    },
    finances: {
        s: 'finances',
        f: '/finances'
    },
    trips: {
        s: 'trips',
        f: '/trips'
    },
    chatwoot: {
        s: 'chatwoot',
        f: '/chatwoot'
    },
    settings: {
        s: 'settings',
        f: '/settings'
    },
    joinRoutes: (...params) => `/${params.join('/')}`.replace(/\/+/g, '/')
};
export const languages = [
    { id: 'UA', label: 'Українська' },
    { id: 'EN', label: 'English' },
    { id: 'PL', label: 'Polski' },
    { id: 'TG', label: 'Тоҷикӣ' },
    { id: 'UZ', label: 'О\'zbek' },
    { id: 'AZ', label: 'Azərbaycan' },
    { id: 'RU', label: 'Русский' }
];
export const NavigationIcons = {
    [NavigationTypes.GOOGLE]: googleMapIcon,
    [NavigationTypes.APPLE]: appleMap,
    [NavigationTypes.WAZE]: wazeMap
};
export const NAVIGATION = [
    { label: 'Apple Maps', value: 'apple', icon: appleMap },
    { label: 'Google Maps', value: 'google', icon: googleMap },
    { label: 'WAZE', value: 'waze', icon: wazeMap }
];
